import React from "react";
import AddGenericModal from "../../Modals/AddGenericModal";
import { Button } from "../../Components/Buttons";
import { patientCategoryLabels } from "./Categories";
import { DynamicFormField } from "./DynamicFormField";

interface PatientFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  fields: any[];
  formData: Record<string, any>;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  isPatientCategory: boolean;
  editingId: number | null;
  category: string;
  isLoading: boolean;
}

export const PatientFormModal: React.FC<PatientFormModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  fields,
  formData,
  setFormData,
  isPatientCategory,
  editingId,
  category,
  isLoading,
}) => {
  const handleFieldChange = (fieldName: string, value: any) => {
    setFormData((prev) => ({ ...prev, [fieldName]: value }));
  };

  const categoryLabel = patientCategoryLabels[category] || category;

  const title = isPatientCategory
    ? "Τροποποίηση Στοιχείων Ασθενή"
    : editingId !== null
      ? `Επεξεργασία (${categoryLabel})`
      : `Νέα Εγγραφή (${categoryLabel})`;

  return (
    <AddGenericModal isOpen={isOpen} onClose={onClose} title={title}>
      <form onSubmit={onSubmit} className="space-y-4">
        {fields.length === 0 ? (
          <div className="text-sm text-slate-500">
            Δεν έχουν οριστεί πεδία για αυτή την κατηγορία.
          </div>
        ) : (
          <div className="space-y-3">
            {fields.map((field: any, index: number) => (
              <DynamicFormField
                key={typeof field === "string" ? field : field.name || index}
                field={field}
                formData={formData}
                onChange={handleFieldChange}
              />
            ))}
          </div>
        )}

        <div className="flex justify-end gap-2 pt-4 border-t">
          <Button type="button" variant="secondary" onClick={onClose}>
            Ακύρωση
          </Button>
          <Button type="submit" variant="primary" isLoading={isLoading}>
            {isPatientCategory || editingId !== null
              ? "Ενημέρωση"
              : "Αποθήκευση"}
          </Button>
        </div>
      </form>
    </AddGenericModal>
  );
};
